import { useContext, useEffect, useState, createContext } from 'react';
import type { ComponentType, FC } from 'react';

import observer from 'saddlebag-observer';

import displayName from '../display-name';
import { getUserPreferences } from '../user-preferences';

import type { UserContext as UserContextType } from '@shared/types/user-context';

interface ContextProps {
  userContext: UserContextType;
}

// @ts-expect-error missing properties
const UserContext = createContext<UserContext>({});

const withUserContext = <P extends ContextProps>(
  Component: ComponentType<P>,
) => {
  const WithUserContext: FC<Omit<P, 'userContext'>> = (props) => {
    const userContext = useContext(UserContext);
    const [isLoggedIn, setIsLoggedIn] = useState(
      userContext.userPreferences.isLoggedIn,
    );

    useEffect(() => {
      const onLoginSuccessHandler = observer.subscribe(
        'sid-login-success',
        () => {
          setIsLoggedIn(true);
        },
      );

      return () => {
        observer.unsubscribe(onLoginSuccessHandler);
      };
    }, []);

    return (
      <Component
        {...(props as P)}
        userContext={{
          ...(userContext as Omit<UserContextType, 'userPreferences'>),
          userPreferences: {
            ...userContext.userPreferences,
            ...getUserPreferences(isLoggedIn),
          },
        }}
      />
    );
  };

  WithUserContext.displayName = displayName(Component);

  return WithUserContext;
};

export { withUserContext };
export default UserContext;
